(function () {
  'use strict';

  var WEBHOOK_URL = 'https://thfab.app.n8n.cloud/webhook/design-builder-submit';

  var DATA = window.DESIGN_BUILDER_DATA;
  if (!DATA) {
    console.warn('Design Builder: DESIGN_BUILDER_DATA not found');
    return;
  }

  var OCCASIONS = DATA.occasions || [];
  var DESIGNS = DATA.designs || [];

  if (OCCASIONS.length === 0) {
    var el = document.getElementById('occList');
    if (el) el.innerHTML = '<p style="padding:14px;font-size:14px;color:#6B4C3B;">No occasions configured yet.</p>';
    return;
  }

  var PRODUCTS = [
    { key: 'mockupBarSmall', label: '1.3oz Chocolate Bar' },
    { key: 'mockupBarLarge', label: '2lb Chocolate Bar' },
    { key: 'mockupTin',      label: '2-Gal Popcorn Tin' },
    { key: 'mockupCanister', label: '8" Cookie Canister' }
  ];

  var state = {
    step: 1,
    occasionSlug: OCCASIONS[0].slug,
    designSlug: null,
    message: { main: '', sub: '', signature: '' },
    logo: { fileName: '', fileDataUrl: '', fileSize: 0, placement: 'bottom' },
    email: ''
  };

  var ICON_CHEV = '<svg viewBox="0 0 24 24" class="icn-chev"><path d="M9 6l6 6-6 6"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 24 24" class="icn icn-arrow"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" class="icn"><path d="M5 12l5 5L20 7"/></svg>';

  function findOccasion(slug) { return OCCASIONS.find(function (o) { return o.slug === slug; }) || OCCASIONS[0]; }
  function findDesign(slug)   { return DESIGNS.find(function (d) { return d.slug === slug; }) || null; }
  function designsForOccasion(slug) { return DESIGNS.filter(function (d) { return d.occasionSlug === slug; }); }
  function designId(design) {
    if (!design) return '';
    var occDesigns = designsForOccasion(design.occasionSlug);
    var idx = occDesigns.findIndex(function (d) { return d.slug === design.slug; });
    return idx >= 0 ? '#' + String(idx + 1).padStart(2, '0') : '';
  }
  function featuredDesignsForOccasion(slug) {
    var featured = designsForOccasion(slug).filter(function (d) { return d.featured; });
    featured.sort(function (a, b) { return (a.featuredOrder || 99) - (b.featuredOrder || 99); });
    return featured.slice(0, 4);
  }
  function escapeHtml(text) {
    var d = document.createElement('div');
    d.textContent = text == null ? '' : String(text);
    return d.innerHTML;
  }

  function setStep(n) {
    state.step = n;
    document.querySelectorAll('.step-view').forEach(function (v) {
      v.hidden = String(n) !== v.getAttribute('data-view');
    });
    document.querySelectorAll('#stepsBar .step').forEach(function (s) {
      var num = parseInt(s.getAttribute('data-step'), 10);
      s.classList.toggle('active', num === n);
      s.classList.toggle('done', num < n);
      s.querySelector('.bubble').innerHTML = num < n ? ICON_CHECK : String(num);
    });
    var stepOf = document.getElementById('stepOf');
    if (stepOf) stepOf.textContent = n === 5 ? 'Complete' : 'Step ' + n + ' of 4';
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (n === 2) renderStep2();
    if (n === 3) renderStep3();
    if (n === 4) renderStep4();
  }

  // --- Step 1 -------------------------------------------------------------

  function renderOccList() {
    var html = OCCASIONS.map(function (o) {
      var active = o.slug === state.occasionSlug;
      var badge = o.badge ? '<span class="badge ' + escapeHtml(o.badge.kind) + '">' + escapeHtml(o.badge.label) + '</span>' : '';
      var thumb = o.thumbnail
        ? '<div class="thumb"><img src="' + escapeHtml(o.thumbnail) + '" alt=""></div>'
        : '<div class="thumb empty">no image</div>';
      var count = designsForOccasion(o.slug).length;
      var countText = count > 0
        ? count + ' design' + (count === 1 ? '' : 's') + ' <span class="count-sep">&middot;</span> Filtered set'
        : 'designs coming soon';
      return '<div class="occ-row ' + (active ? 'active' : '') + '" data-slug="' + escapeHtml(o.slug) + '" role="button" tabindex="0">' +
        thumb +
        '<div class="meta"><div class="name">' + escapeHtml(o.name) + badge + '</div><p class="desc">' + escapeHtml(o.description) + '</p><div class="count">' + countText + '</div></div>' +
        '<div class="chev">' + ICON_CHEV + '</div>' +
      '</div>';
    }).join('');
    document.getElementById('occList').innerHTML = html;
  }

  function renderOccPreview() {
    var o = findOccasion(state.occasionSlug);
    var featured = featuredDesignsForOccasion(o.slug);
    var total = designsForOccasion(o.slug).length;
    var badge = o.badge ? '<span class="badge ' + escapeHtml(o.badge.kind) + '">' + escapeHtml(o.badge.label) + '</span>' : '';

    var body;
    var showAllBtn = total > 0
      ? '<button class="btn btn-primary btn-sm" data-action="continue">Show Designs ' + ICON_ARROW + '</button>'
      : '';
    if (total > 0) {
      var tiles = featured.map(function (d) {
        var bg = d.image ? 'background-image:url(' + escapeHtml(d.image) + ');background-size:cover;background-position:center;' : '';
        var tileClass = d.image ? 'tile has-image' : 'tile';
        return '<div class="' + tileClass + '" data-slug="' + escapeHtml(d.slug) + '" data-jump="1" style="' + bg + '"><div class="scrim"><div class="design-name">' + escapeHtml(d.title) + '</div><div class="design-meta">' + designId(d) + '</div></div></div>';
      }).join('');
      for (var i = featured.length; i < 4; i++) {
        tiles += '<div class="tile empty"><div class="lbl">More designs<br>coming soon</div></div>';
      }
      body = '<div class="preview-tiles">' + tiles + '</div>';
    } else {
      body = '<div class="preview-empty"><div class="count">Designs coming soon</div><p>This occasion is set up. Designs will appear here once your team adds them.</p></div>';
    }

    document.getElementById('previewMount').innerHTML =
      '<div class="preview"><div class="preview-head">' +
        '<div><div class="eyebrow">' + escapeHtml(o.eyebrow || '') + '</div><h2>' + escapeHtml(o.name) + '</h2><p class="desc">' + escapeHtml(o.headerDescription || o.description) + '</p></div>' +
        '<div class="head-right">' + showAllBtn + '</div>' +
      '</div>' + body + '</div>';
  }

  function setOccasion(slug) {
    if (slug === state.occasionSlug) return;
    state.occasionSlug = slug;
    state.designSlug = null;
    renderOccList();
    renderOccPreview();
  }

  // --- Step 2 -------------------------------------------------------------

  function renderStep2() {
    var o = findOccasion(state.occasionSlug);
    var occDesigns = designsForOccasion(o.slug);

    document.getElementById('step2Sub').textContent =
      occDesigns.length + ' design' + (occDesigns.length === 1 ? '' : 's') + ' in ' + o.name + '.';

    var thumbHTML = o.thumbnail
      ? '<img src="' + escapeHtml(o.thumbnail) + '" alt="" class="occ-banner-thumb-img">'
      : '<div class="occ-banner-thumb"></div>';

    var continueDisabled = state.designSlug ? '' : ' disabled';
    document.getElementById('occBanner').innerHTML =
      '<div class="occ-banner-inner">' + thumbHTML +
      '<div class="occ-banner-body">' +
        '<div class="list-label">Occasion</div>' +
        '<div class="nm">' + escapeHtml(o.name) + '</div>' +
        '<button class="link-sm" data-action="back">Change occasion</button>' +
      '</div>' +
      '<button class="btn btn-primary btn-sm" data-action="continue" id="occBannerContinue"' + continueDisabled + '>Continue to Message</button>' +
      '</div>';

    if (occDesigns.length === 0) {
      document.getElementById('designGrid').innerHTML =
        '<div class="empty-designs"><p>No designs in this occasion yet.</p><p style="font-size:12px;">Add some in Airtable and re-run the sync.</p></div>';
    } else {
      var html = occDesigns.map(function (d) {
        var selected = d.slug === state.designSlug;
        var art;
        if (d.image) {
          art = '<div class="design-art has-image" style="background-image:url(' + escapeHtml(d.image) + ');"></div>';
        } else {
          art = '<div class="design-art"><div class="design-art-inner"><div class="design-art-main">' + escapeHtml(d.defaultMain || d.title) + '</div></div></div>';
        }
        return '<div class="design-card ' + (selected ? 'selected' : '') + '" data-slug="' + escapeHtml(d.slug) + '">' +
          art +
          '<div class="design-card-foot"><div class="design-card-title">' + escapeHtml(d.title) + '</div><div class="design-card-tag">' + designId(d) + '</div></div>' +
          (selected ? '<div class="selected-mark">' + ICON_CHECK + '</div>' : '') +
        '</div>';
      }).join('');
      document.getElementById('designGrid').innerHTML = html;
    }

    renderStep2Preview();
    document.getElementById('step2Continue').disabled = !state.designSlug;
  }

  function renderStep2Preview() {
    var d = state.designSlug ? findDesign(state.designSlug) : null;
    var html;
    if (d) {
      var mockups = PRODUCTS.map(function (p) {
        var url = d[p.key];
        var cell;
        if (url) {
          cell = '<div class="mockup-cell"><div class="mockup-img" style="background-image:url(' + escapeHtml(url) + ');"></div><div class="mockup-label">' + escapeHtml(p.label) + '</div></div>';
        } else {
          cell = '<div class="mockup-cell"><div class="mockup-img empty"><span>Mockup pending</span></div><div class="mockup-label">' + escapeHtml(p.label) + '</div></div>';
        }
        return cell;
      }).join('');
      html = '<div class="design-preview-inner">' +
        '<div class="list-label">Example mockups with this design</div>' +
        '<h3>' + escapeHtml(d.title) + '</h3>' +
        '<p class="pv-sub">' + designId(d) + '</p>' +
        '<div class="mockup-grid">' + mockups + '</div>' +
      '</div>';
    } else {
      html = '<div class="design-preview-inner empty"><div class="list-label">Example mockups with this design</div><p class="pv-sub">Pick a design on the left to preview it on our 4 flagship products.</p></div>';
    }
    document.getElementById('designPreview').innerHTML = html;
  }

  function setDesign(slug) {
    state.designSlug = slug;
    renderStep2();
  }

  // --- Step 3 -------------------------------------------------------------

  function renderStep3() {
    var d = findDesign(state.designSlug);
    if (d && !state.message.main) {
      state.message.main = d.defaultMain || '';
      state.message.sub = d.defaultSub || '';
      document.getElementById('msgMain').value = state.message.main;
      document.getElementById('msgSub').value = state.message.sub;
    }
    updateMessageCounts();
    renderMsgPreview();
    validateStep3();
  }

  function updateMessageCounts() {
    document.getElementById('mainCount').textContent = state.message.main.length + '/40';
    document.getElementById('subCount').textContent = state.message.sub.length + '/60';
    document.getElementById('sigCount').textContent = state.message.signature.length + '/280';
  }

  function renderMsgPreview() {
    var d = findDesign(state.designSlug);
    var bg = d && d.image ? 'background-image:url(' + escapeHtml(d.image) + ');background-size:cover;background-position:center;' : '';
    var artClass = d && d.image ? 'msg-preview-art has-image' : 'msg-preview-art';
    var designLabel = d ? (designId(d) + ' ' + d.title) : '';
    document.getElementById('msgPreview').innerHTML =
      '<div class="msg-preview-label">Selected design</div>' +
      '<div class="msg-preview-frame"><div class="' + artClass + '" style="' + bg + '"></div></div>' +
      '<div class="msg-preview-meta"><div class="lbl">Design</div><div class="val">' + escapeHtml(designLabel) + '</div></div>' +
      (state.message.signature ? '<div class="msg-preview-back"><div class="lbl">Notes for our team</div><p>' + escapeHtml(state.message.signature) + '</p></div>' : '');
  }

  function validateStep3() {
    document.getElementById('step3Continue').disabled = state.message.main.trim().length === 0;
  }

  // --- Step 4 -------------------------------------------------------------

  function renderStep4() {
    renderOrderSummary();
    validateStep4();
  }

  function renderOrderSummary() {
    var o = findOccasion(state.occasionSlug);
    var d = findDesign(state.designSlug);
    var placementLabel = { top: 'Top center', bottom: 'Bottom center', side: 'Side wrap' }[state.logo.placement];
    var designSummary = d ? (designId(d) + ' ' + d.title) : '—';

    document.getElementById('orderSummary').innerHTML =
      '<div class="msg-preview-label">Order summary</div>' +
      '<dl class="sum-list">' +
        '<div><dt>Occasion</dt><dd>' + escapeHtml(o.name) + '</dd></div>' +
        '<div><dt>Design</dt><dd>' + escapeHtml(designSummary) + '</dd></div>' +
        '<div><dt>Message</dt><dd>' + escapeHtml(state.message.main || '—') + '</dd></div>' +
        (state.message.sub ? '<div><dt>Sub</dt><dd>' + escapeHtml(state.message.sub) + '</dd></div>' : '') +
        (state.message.signature ? '<div><dt>Additional notes</dt><dd>' + escapeHtml(state.message.signature) + '</dd></div>' : '') +
        '<div><dt>Logo</dt><dd>' + escapeHtml(state.logo.fileName || 'Not uploaded (optional)') + '</dd></div>' +
        '<div><dt>Placement</dt><dd>' + placementLabel + '</dd></div>' +
        '<div><dt>Email</dt><dd>' + escapeHtml(state.email || '—') + '</dd></div>' +
      '</dl>';
  }

  function validateStep4() {
    var validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email);
    document.getElementById('submitBtn').disabled = !validEmail;
  }

  function handleFile(file) {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) { alert('File is too large. Maximum 10MB.'); return; }
    state.logo.fileName = file.name;
    state.logo.fileSize = file.size;
    var reader = new FileReader();
    reader.onload = function (e) {
      state.logo.fileDataUrl = e.target.result;
      document.getElementById('dzInner').innerHTML =
        '<p class="dz-main" style="color:#4A7C59;">&check; ' + escapeHtml(file.name) + '</p>' +
        '<p class="dz-sub">' + Math.round(file.size / 1024) + ' KB &middot; click to change</p>';
      renderOrderSummary();
    };
    reader.readAsDataURL(file);
  }

  function submit() {
    var o = findOccasion(state.occasionSlug);
    var d = findDesign(state.designSlug);
    var payload = {
      occasion: { slug: o.slug, name: o.name },
      design: {
        slug: d ? d.slug : null,
        title: d ? d.title : null,
        id: d ? designId(d) : null
      },
      message: {
        main: state.message.main,
        sub: state.message.sub,
        signature: state.message.signature
      },
      logo: {
        fileName: state.logo.fileName,
        fileDataUrl: state.logo.fileDataUrl,
        fileSize: state.logo.fileSize,
        placement: state.logo.placement
      },
      customerEmail: state.email,
      productLink: window.location.origin + '/pages/design-templates?occasion=' + encodeURIComponent(o.slug) + (d ? '&design=' + encodeURIComponent(d.slug) : ''),
      submittedAt: new Date().toISOString()
    };

    var btn = document.getElementById('submitBtn');
    var originalLabel = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = 'Sending&hellip;';
    }

    fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (r.ok) {
        window.dispatchEvent(new CustomEvent('design-builder:submit', { detail: payload }));
        setStep(5);
      } else {
        alert('Sorry, something went wrong sending your submission. Please try again.');
        if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
      }
    }).catch(function (err) {
      console.error('Design Builder submit error:', err);
      alert('We could not reach our servers. Check your connection and try again.');
      if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
    });
  }

  // --- Events -------------------------------------------------------------

  document.addEventListener('click', function (e) {
    var occRow = e.target.closest('.occ-row');
    if (occRow) { setOccasion(occRow.getAttribute('data-slug')); return; }

    // Step 1 featured tiles: jump straight into Step 2 with the design selected
    var jumpTile = e.target.closest('.tile[data-jump="1"]');
    if (jumpTile && state.step === 1) {
      var jumpSlug = jumpTile.getAttribute('data-slug');
      if (jumpSlug) {
        state.designSlug = jumpSlug;
        setStep(2);
        return;
      }
    }

    var designCard = e.target.closest('.design-card');
    if (designCard && state.step === 2) { setDesign(designCard.getAttribute('data-slug')); return; }

    var actBtn = e.target.closest('[data-action]');
    if (actBtn && !actBtn.disabled) {
      var action = actBtn.getAttribute('data-action');
      if (action === 'continue') {
        if (state.step === 1 && designsForOccasion(state.occasionSlug).length > 0) setStep(2);
        else if (state.step === 2 && state.designSlug) setStep(3);
        else if (state.step === 3 && state.message.main.trim()) setStep(4);
      } else if (action === 'back') {
        setStep(state.step - 1);
      } else if (action === 'submit') {
        submit();
      } else if (action === 'restart') {
        state.designSlug = null;
        state.message = { main: '', sub: '', signature: '' };
        state.logo = { fileName: '', fileDataUrl: '', fileSize: 0, placement: 'bottom' };
        state.email = '';
        ['msgMain','msgSub','msgSig','customerEmail','logoFile'].forEach(function (id) { document.getElementById(id).value = ''; });
        document.getElementById('dzInner').innerHTML = '<p class="dz-main">Drop your logo here or click to browse</p><p class="dz-sub">PDF, PNG, SVG or JPG &middot; up to 10MB</p>';
        setStep(1);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && state.step === 1) {
      var row = e.target.closest && e.target.closest('.occ-row');
      if (row) { e.preventDefault(); setOccasion(row.getAttribute('data-slug')); }
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.id === 'msgMain') { state.message.main = t.value; updateMessageCounts(); renderMsgPreview(); validateStep3(); }
    else if (t.id === 'msgSub') { state.message.sub = t.value; updateMessageCounts(); renderMsgPreview(); }
    else if (t.id === 'msgSig') { state.message.signature = t.value; updateMessageCounts(); renderMsgPreview(); }
    else if (t.id === 'customerEmail') { state.email = t.value.trim(); renderOrderSummary(); validateStep4(); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.id === 'logoFile') { handleFile(t.files[0]); }
    else if (t.name === 'placement') {
      state.logo.placement = t.value;
      document.querySelectorAll('#placementList .placement-row').forEach(function (row) {
        row.classList.toggle('selected', row.querySelector('input').checked);
      });
      renderOrderSummary();
    }
  });

  var dropzone = document.querySelector('.dropzone');
  if (dropzone) {
    ['dragover','dragenter'].forEach(function (ev) { dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.add('over'); }); });
    ['dragleave','drop'].forEach(function (ev) { dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.remove('over'); }); });
    dropzone.addEventListener('drop', function (e) { handleFile(e.dataTransfer.files[0]); });
  }

  renderOccList();
  renderOccPreview();
})();
